//
// mobile conditional
//
export function isMobile() {
	return window.matchMedia('(max-width: 767px)').matches;
}

//
// set cookie
//
export function setCookie(cName, cValue, expDays) {
	let date = new Date();
	date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
	const expires = "expires=" + date.toUTCString();
	document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
//
// get cookie
//
export function getCookie(cName) {
	const name = cName + "=";
	const cDecoded = decodeURIComponent(document.cookie); //to be careful
	const cArr = cDecoded .split('; ');
	let res;
	cArr.forEach(val => {
		if (val.indexOf(name) === 0) res = val.substring(name.length);
	})
	return res;
}

// Function to set the language cookie
export function setLanguageCookie(value) {
	setCookie('selectedLanguage', value, 30); // Expires in 30 days
}

// Function to get the language cookie value
export function getLanguageCookie() {
	return getCookie('selectedLanguage');
}


//
// Function to check if a section is in view
//
export function isElementInView(element) {
    const rect = element.getBoundingClientRect();
    return (
        (rect.top >= 0 && rect.top <= window.innerHeight) ||
        (rect.bottom >= 0 && rect.bottom <= window.innerHeight)
    );
}

//
// universal smooth scroll
//
export function smoothScroll(target) {
	const element = document.querySelector(target);
	// console.log(element);
	if (element) {
		const offset = 100; // Offset value in pixels
		const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;

		window.scrollTo({
			behavior: 'smooth',
			top: targetPosition,
		});
	}
}

//
// lazyload videos
//
export function lazyLoadVideos() {

	// Get all the images with the "data-src" attribute
	const images = document.querySelectorAll('video.lazy-video');

	// Specify the distance below the viewport to load the images (in pixels)
	const distanceBelowViewport = window.innerHeight * 0.5;

	// Configure the Intersection Observer
	const config = {
		rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
		// threshold: 0 // Adjust the threshold as needed
	};

	// Create a new Intersection Observer
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const video = entry.target;
				for (var source in video.children) {
					var videoSource = video.children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
						videoSource.removeAttribute('data-src');
					}
				}
				video.load();
				video.play();
				video.classList.remove("lazy-video");

				observer.unobserve(video);
			}
		});
	}, config);

	// Start observing each image
	images.forEach(image => {
		observer.observe(image);
	});
}
// document.addEventListener("DOMContentLoaded", lazyLoadVideos);
export function lazyLoadImages() {
	// Get all the images with the "data-src" attribute
	const images = document.querySelectorAll('img[data-src]');

	// Specify the distance below the viewport to load the images (in pixels)
	const distanceBelowViewport = window.innerHeight * 0.5;

	// Configure the Intersection Observer
	const config = {
		rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
		// threshold: 0 // Adjust the threshold as needed
	};

	// Create a new Intersection Observer
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const image = entry.target;

				// Set the "src" attribute with the value from "data-src"
				image.src = image.dataset.src;
				image.removeAttribute('data-src');

				// Animate the opacity of the image
				image.style.transition = 'opacity 0.15s';
				image.style.opacity = '0';
				image.onload = () => {
					image.style.opacity = '1';
					image.classList.add('lazy-loaded');
				};

				// // Remove???
				// // Add a height attribute to the image
				// const imageHeight = image.getAttribute('height');
				// if (!imageHeight) {
				// 	const computedStyle = window.getComputedStyle(image);
				// 	image.style.height = "computedStyle.getPropertyValue('height')";
				// }

				// Stop observing the current image
				observer.unobserve(image);
			}
		});
	}, config);

	// Start observing each image
	images.forEach(image => {
		observer.observe(image);
	});
}

// export function dropDownImage(image, el) {
// 	const optionImageURL = image.getAttribute('data-image');
// 	console.log(optionImageURL);
// 	if(optionImageURL) {
// 		// Create <img> element for the image
// 		const optionImage = document.createElement('img');
// 		optionImage.src = optionImageURL;
// 		optionImage.alt = image.textContent; // Set alt text to option text
// 		el.appendChild(optionImage);
// 		// console.log(optionImageURL);
// 	}
// }
